export const testimonials = [
  {
    quote_en: "Gulf TechLab didn't feel like an agency — they felt like a co-founder. Shipped twice as fast as our last vendor.",
    quote_ar: "لم يبدوا كوكالة — بل كشريك تأسيسي. نفذوا بسرعة مضاعفة مقارنة بالمزود السابق.",
    name: "Layla Al-Hashemi",
    role_en: "VP, Product — Gulf Retail Group",
    role_ar: "نائب الرئيس للمنتج — مجموعة خليج التجزئة",
  },
  {
    quote_en: "Their AI team understood our regulatory environment on day one. That saved us six months.",
    quote_ar: "فهم فريق الذكاء الاصطناعي بيئتنا التنظيمية من اليوم الأول — وفر علينا ستة أشهر.",
    name: "Omar Khalid",
    role_en: "CTO — Regional Fintech",
    role_ar: "الرئيس التقني — تقنية مالية",
  },
  {
    quote_en: "We finally have a partner who is fluent in both KPIs and creativity. Rare combination, huge impact.",
    quote_ar: "أخيراً لدينا شريك يجيد لغة المؤشرات والإبداع. تركيبة نادرة وأثر كبير.",
    name: "Sara Mubarak",
    role_en: "CMO — Hospitality Group",
    role_ar: "مدير التسويق — مجموعة ضيافة",
  },
  {
    quote_en: "The consultancy team reframed our operating model. Margins are up, team is happier.",
    quote_ar: "أعاد فريق الاستشارات صياغة نموذج التشغيل. ارتفعت الهوامش وتحسن الفريق.",
    name: "Rashid Al-Mansoori",
    role_en: "CEO — Logistics Operator",
    role_ar: "الرئيس التنفيذي — شركة لوجستية",
  },
];
